import { getBranchCodeFromPath, getBranchData, isValidBranchCode } from '../config/branches-config';

/**
 * Филиал для форм: на лендингах расчёта (/raschet-*) — из ?branch=, иначе —
 * филиал страницы. pageBranch — результат useBranchCode() (учитывает хост при
 * BRANCH_ROUTING=host); без него филиал берётся из пути, как раньше.
 */
export function getLeadFormBranch(pathname: string, search: string, pageBranch?: string) {
  const requested = new URLSearchParams(search).get('branch');
  const isCalculationPage = /^\/(?:[a-z]{2}\/)?raschet-(?:konstruktsii|zdaniya|ferm)\/?$/.test(pathname);
  if (isCalculationPage && requested && isValidBranchCode(requested)) return requested;
  return pageBranch && isValidBranchCode(pageBranch) ? pageBranch : getBranchCodeFromPath(pathname);
}

export function getLeadFormCity(pathname: string, search: string, pageBranch?: string) {
  return getBranchData(getLeadFormBranch(pathname, search, pageBranch))?.name || 'Санкт-Петербург';
}
